const VideoChatTrackKind = {
  audio: 'audio',
  video: 'video',
  data: 'data',
};

export default VideoChatTrackKind;
